import { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

export function PayPalTopUp({ orgId, credits, onGranted }) {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    api.get("/billing/paypal/config").then(r => setCfg(r.data)).catch(() => setCfg({ enabled: false }));
  }, []);
  if (!cfg) return null;
  if (!cfg.enabled) {
    return (
      <p className="k-muted" data-testid="paypal-disabled" style={{ fontSize: 12 }}>
        PayPal isn’t configured yet — add PAYPAL_CLIENT_ID and PAYPAL_SECRET to enable it.
      </p>
    );
  }
  return (
    <div data-testid="paypal-topup">
      <div className="k-muted" style={{ fontSize: 11, marginBottom: 6 }}>
        <span className="sr-only">PayPal</span>
      </div>
      <PayPalScriptProvider options={{ clientId: cfg.client_id, currency: cfg.currency || "GBP", intent: "capture" }}>
        <PayPalButtons
          style={{ layout: "horizontal", color: "gold", label: "paypal", height: 40, tagline: false }}
          forceReRender={[credits, orgId]}
          createOrder={async () => {
            const { data } = await api.post(`/billing/paypal/orgs/${orgId}/create-order`, { credits });
            return data.order_id;
          }}
          onApprove={async (data) => {
            try {
              const { data: res } = await api.post(`/billing/paypal/orgs/${orgId}/capture-order/${data.orderID}`);
              toast.success(`Added ${res.granted_credits} credits via PayPal`);
              if (onGranted) onGranted(res.granted_credits);
            } catch (e) {
              toast.error(errMsg(e));
            }
          }}
          onError={() => toast.error("PayPal could not complete the payment")}
        />
      </PayPalScriptProvider>
    </div>
  );
}
